import React from "react";
import StickySidebar from "accountOwner/pages/Scheduler/components/StickySidebar";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import OfficeFilter from "./OfficeFilterList";
import StaffFilter from "./StaffFilter";
import { withTranslation } from "react-i18next";
import StatusCheckFilter from "./StatusCheckFilter";
import styles from "accountOwner/pages/Notes/Notes.module.scss";
import PriorityCheckFilter from "./PriorityCheckFilter";

const FilterOfficePolicy = ({
  t,
  isSidebarActive,
  handleSidebarToggle,
  resetFilter,
  officeFilter,
  setOfficeFilter,
  handleApplyFilters,
  staffFilter,
  setStaffFilter,
  statusFilter,
  priorityFilter,
  setStatusFilter,
  setPriorityFilter,
  isFilterApply,
  isStaff,
  accountOwnerId,
}) => {
  const handleApplyFilter = () => {
    handleApplyFilters();
    if (window.matchMedia("(max-width: 767px)").matches) handleSidebarToggle();
  };

  const handleResetFilter = () => {
    resetFilter();
    if (window.matchMedia("(max-width: 767px)").matches) handleSidebarToggle();
  };

  const handleClose = () => {
    if (window.matchMedia("(max-width: 767px)").matches) handleSidebarToggle();
  };

  return (
    <StickySidebar
      isSidebarActive={isSidebarActive}
      handleSidebarToggle={handleSidebarToggle}
      resetFilter={handleResetFilter}
    >
      <span className={styles.notes_filter}>
        {t("taskManagement.filters")}
        {isFilterApply && <span className={styles.red_dot} />}
      </span>
      <Accordion preExpanded={["a"]} className="filter-accordion" allowZeroExpanded>
        <AccordionItem uuid="a">
          <AccordionItemHeading>
            <AccordionItemButton>{t("taskManagement.offices")}</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <OfficeFilter
              selectedOffice={officeFilter}
              setOfficeFilter={setOfficeFilter}
              isStaff={isStaff}
              accountOwnerId={accountOwnerId}
              t={t}
            />
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid="b">
          <AccordionItemHeading>
            <AccordionItemButton>
              {isStaff ? t("taskManagement.assigonr") : t("taskManagement.staffMembers")}
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <StaffFilter
              seletedStaff={staffFilter}
              setStaffFilter={setStaffFilter}
              isStaff={isStaff}
              accountOwnerId={accountOwnerId}
              t={t}
            />
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid="c">
          <AccordionItemHeading>
            <AccordionItemButton>{t("notes.status")}</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <StatusCheckFilter seletedStatus={statusFilter} setStatusFilter={setStatusFilter} />
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid="d">
          <AccordionItemHeading>
            <AccordionItemButton>{t("taskManagement.priority")}</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <PriorityCheckFilter
              seletedPriorty={priorityFilter}
              setPriorityFilter={setPriorityFilter}
            />
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
      <div className="filter-btn-box filter-btn-box--sticky-footer">
        <button
          type="button"
          className="button button-round button-shadow mr-3"
          title="apply"
          onClick={handleApplyFilter}
        >
          {t("taskManagement.apply")}
        </button>
        <button
          type="button"
          className="button button-round button-border button-dark reset-btn"
          title="reset"
          onClick={handleResetFilter}
        >
          {t("taskManagement.reset")}
        </button>
        <button
          type="button"
          className="button button-round button-border button-dark cancel-btn"
          title="close"
          onClick={handleClose}
        >
          {t("taskManagement.close")}
        </button>
      </div>
    </StickySidebar>
  );
};

export default withTranslation()(FilterOfficePolicy);
